"use client";

import { useTranslations } from "next-intl";
import { Link } from "../i18n/routing";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";

export default function Footer() {
  const t = useTranslations("footer");
  const menuT = useTranslations("common.menu");
  const servicesT = useTranslations("home.services");

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          <div className="mb-4 sm:mb-0">
            <h3 className="text-xl font-semibold mb-3 md:mb-4">
              {t("companyName")}
            </h3>
            <p className="text-gray-400 mb-2">{t("companyNameChinese")}</p>
            <div className="flex items-start mt-4 md:mt-6 space-y-2 md:space-y-3 flex-col">
              <div className="flex items-start">
                <FaMapMarkerAlt className="mt-1 mr-2 md:mr-3 text-blue-400 flex-shrink-0" />
                <p className="text-gray-300 text-sm md:text-base">
                  {t("address")}
                </p>
              </div>
              <div className="flex items-center">
                <FaPhone className="mr-2 md:mr-3 text-blue-400 flex-shrink-0" />
                <p className="text-gray-300 text-sm md:text-base">{t("tel")}</p>
              </div>
              <div className="flex items-center">
                <FaEnvelope className="mr-2 md:mr-3 text-blue-400 flex-shrink-0" />
                <p className="text-gray-300 text-sm md:text-base">
                  {t("email")}
                </p>
              </div>
            </div>
          </div>

          <div className="mb-4 sm:mb-0">
            <h3 className="text-xl font-semibold mb-3 md:mb-4">
              {t("quickLinks")}
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link
                  href="/"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {menuT("home")}
                </Link>
              </li>
              <li>
                <Link
                  href="/about"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {menuT("about")}
                </Link>
              </li>

              <li>
                <Link
                  href="/career"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {menuT("career")}
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {menuT("contact")}
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {menuT("privacy")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="mb-4 sm:mb-0">
            <h3 className="text-xl font-semibold mb-3 md:mb-4">
              {t("ourServices")}
            </h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link
                  href="/services/accounting"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {servicesT("accounting.title")}
                </Link>
              </li>
              <li>
                <Link
                  href="/services/audit"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {servicesT("audit.title")}
                </Link>
              </li>
              <li>
                <Link
                  href="/services/corporate-tax"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {servicesT("corporateTax.title")}
                </Link>
              </li>
              <li>
                <Link
                  href="/services/individual-tax"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {servicesT("individualTax.title")}
                </Link>
              </li>
              <li>
                <Link
                  href="/services/tax-planning"
                  className="text-gray-300 hover:text-blue-400 transition text-sm md:text-base">
                  {servicesT("taxPlanning.title")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 md:mt-10 pt-4 md:pt-6 text-center">
          <p className="text-gray-400 text-sm">
            {t("copyright", { YEAR: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
}
